// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'neueMontreal', 'neueMontreal Fallback'"},"className":"__className_c24fc6","variable":"__variable_c24fc6"};